export * from './src/quickpages-materializedpages-v1-materialized-page-materialized-pages.meta.js';
